import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const agentListRoutes = {
  path: 'agent-list',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.agent.list'),
  },
  children: [
    {
      path: '',
      name: 'agentList',
      component: () => lazyLoadView(import('@views/AgentList/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
    {
      path: 'registration',
      name: 'agentRegistration',
      component: () =>
        lazyLoadView(import('@views/AgentList/registration.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.agent.registration'),
      },
    },
    {
      path: 'edit',
      name: 'agentDetail',
      component: () => lazyLoadView(import('@views/AgentList/detail.vue')),
      meta: {
        authRequired: [
          ROLE.AGENT_ADMIN,
          ROLE.AGENT_AUDIT,
          ROLE.AGENT_SUB,
          ROLE.AGENT_ANNOUNCE,
        ],
        label: i18n.t('pages.agentDetail'),
      },
    },
    {
      path: ':id',
      name: 'agentDetail',
      component: () => lazyLoadView(import('@views/AgentList/detail.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.agent.detail'),
      },
    },
  ],
}

export default agentListRoutes
